// @ts-nocheck
export default {
  data() {
    return {
      sortings: {
        HospitalName: [
          undefined,
          { by: "hospital-name", icon: "▲", direction: "asc" },
          { by: "hospital-name", icon: "▼", direction: "desc" },
        ],
        City: [
          undefined,
          { by: "city", icon: "▲", direction: "asc" },
          { by: "city", icon: "▼", direction: "desc" },
        ],
      },
      currentSortKey: "HospitalName",
      currentSortIndex: 0,
      listOrder: undefined,
    };
  },

  computed: {
    HospitalNameColumnSortingIcon() {
      if (this.currentSortKey === "HospitalName") {
        return this.sortings.HospitalName[this.currentSortIndex]?.icon || "▼▲";
      }
      return "▼▲";
    },
    CityColumnSortingIcon() {
      if (this.currentSortKey === "City") {
        return this.sortings.City[this.currentSortIndex]?.icon || "▼▲";
      }
      return "▼▲";
    },
  },

  methods: {
    changeListOrder(key, callback) {
      if (this.currentSortKey === key) {
        this.updateCurrentSortingIndex(callback);
        return;
      }

      this.currentSortKey = key;
      this.currentSortIndex = 0;
      this.updateCurrentSortingIndex(callback);
    },
    updateCurrentSortingIndex(callback) {
      if (
        this.currentSortIndex ===
        this.sortings[this.currentSortKey].length - 1
      ) {
        this.currentSortIndex = 0;
        this.listOrder = this.sortings[this.currentSortKey][0];
        callback();
        return;
      }

      this.currentSortIndex++;
      this.listOrder =
        this.sortings[this.currentSortKey][this.currentSortIndex];
      return callback();
    },
  },
};
